import { render, staticRenderFns } from "./simulator.vue?vue&type=template&id=55d361fa&scoped=true"
import script from "./simulator.vue?vue&type=script&lang=js"
export * from "./simulator.vue?vue&type=script&lang=js"
import style0 from "./simulator.vue?vue&type=style&index=0&id=55d361fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d361fa",
  null
  
)

export default component.exports